import React from 'react'
import PlayerHead from '../../components/player_head/PlayerHead'
import {
    getPlayerURL,
    getTeamURL,
    getSportFromLeague,
    getPlayerImageURL,
} from '../../utils/js/shared_helpers'

function CustomResultsItem(props) {
    return (
        <div className="players-results-wrap container-fluid">
            <div className="label-wrap col-xs-12 col-sm-2">
                <h3 className="custom-results-title">{props.type.toUpperCase()}</h3>
            </div>
            <div className="results-wrap col-xs-12 col-sm-10 no-padding">
                {props.data &&
                    props.data.map((item, index) => {
                        let name_str = item.city + ' ' + item.team_name
                        let details_str = item.league
                        let playerImgUrl = ''

                        if (props.type === 'players') {
                            name_str = item.player_name
                            details_str = item.league + ' - ' + item.city
                            playerImgUrl = getPlayerImageURL(item.id, 'xs', item.league)

                            item.url = getPlayerURL(
                                item.player_name.split(' ')[0],
                                item.player_name.split(' ')[1],
                                item.id,
                                item.league.toLowerCase()
                            )
                        } else {
                            const league = item.league.toLowerCase()
                            item.url = getTeamURL(
                                item.city,
                                item.team_name,
                                item.league.toLowerCase()
                            )
                            item.name = item.team_name
                            const sport = getSportFromLeague(league)
                            item.thumb =
                                'https://images.rogersdigitalmedia.com/www.sportsnet.ca/team_logos/59x59/' +
                                sport +
                                '/' +
                                league +
                                '/' +
                                item.city.replace(' ', '-').toLowerCase() +
                                '-' +
                                item.team_name.replace(' ', '-').toLowerCase() +
                                '.png'
                        }

                        return (
                            <div className="player_cont col-xs-12 col-sm-6 col-lg-4" key={index}>
                                <div className="player_inner_cont">
                                    <a href={item.url}>
                                        <div className="player_image item">
                                            {props.type === 'teams' && (
                                                <img src={item.thumb} width="50" alt={item.name} />
                                            )}

                                            {props.type === 'players' && (
                                                <PlayerHead
                                                    imageUrl={playerImgUrl}
                                                    imageWidth={50}
                                                    animate={false}
                                                />
                                            )}
                                        </div>
                                        <div className="player_details">
                                            <div className="name">{name_str}</div>
                                            <div className="team-details">{details_str}</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        )
                    })}
            </div>
        </div>
    )
}
export default CustomResultsItem
